import { render, staticRenderFns } from "./WalletCallBackMobile.vue?vue&type=template&id=c8a26c00&scoped=true"
import script from "./WalletCallBackMobile.vue?vue&type=script&lang=js"
export * from "./WalletCallBackMobile.vue?vue&type=script&lang=js"
import style0 from "./WalletCallBackMobile.vue?vue&type=style&index=0&id=c8a26c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a26c00",
  null
  
)

export default component.exports